import BlogSingleContainer from "../../Componant/Blog/BlogSingle";

const BlogSingle = () => {
  return (
    <div className="page-body">
      <BlogSingleContainer />
    </div>
  );
};

export default BlogSingle;
